import { FeatureFlagKey } from "@redotech/feature-flags-model/keys";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { createContext, memo, ReactNode, useContext } from "react";

export interface NavigationVersionContextValue {
  newNavigationEnabled: boolean;
}

export const NavigationVersionContext =
  createContext<NavigationVersionContextValue>({ newNavigationEnabled: false });
NavigationVersionContext.displayName = "NavigationVersionContext";

export const NavigationVersionProvider = memo(
  function NavigationVersionProvider({ children }: { children: ReactNode }) {
    const team = useContext(TeamContext);
    const newNavigationEnabled =
      team?.featureFlags[FeatureFlagKey.NEW_NAVIGATION] === true;

    return (
      <NavigationVersionContext.Provider value={{ newNavigationEnabled }}>
        {children}
      </NavigationVersionContext.Provider>
    );
  },
);
